module.exports = __webpack_public_path__ + "static/media/hithit.4fdf3aec.jpg";